// Register GSAP Plugins
gsap.registerPlugin(ScrollTrigger);

// Function to create the text and image reveal animation for each section
function createTextRevealAnimation(section) {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 75%", // When the section is 75% in view
      end: "bottom top",
       toggleActions: "play none none none", // Ensures no reset or replay
      once: true, // The animation runs only once
    }
  });
  
  const allLinks = gsap.utils.toArray("p");
  const lineOne = section.querySelector(".one");
  const lineTwo = section.querySelector(".two");
  const lineThree = section.querySelector(".three");
  const button = section.querySelector(".buy-fire");
  const image = section.querySelector(".k-column-right img"); // Select the image

  // Check if the section has the "reverse" class to adjust animation direction
  const isReversed = section.classList.contains("reverse");

  // Set initial states for text and image based on direction
  if (isReversed) {
    // If reversed, image comes in from the left, text from the right
    gsap.set([lineOne, lineThree], { xPercent: 101, autoAlpha: 0 }); // Text from right
    gsap.set(lineTwo, { xPercent: -101, autoAlpha: 0 });
    gsap.set(image, { xPercent: -100, autoAlpha: 0, scale: 0.75 }); // Image from left
    gsap.set(button, { xPercent: 0, autoAlpha: 0, scale: 0.75 });
  } else {
    // Default: image comes in from the right, text from the left
    gsap.set([lineOne, lineThree], { xPercent: -101, autoAlpha: 0 }); // Text from left
    gsap.set(lineTwo, { xPercent: 101, autoAlpha: 0 });
    gsap.set(button, { xPercent: 0, autoAlpha: 0, scale: 0.75 });
    gsap.set(image, { xPercent: 100, autoAlpha: 0, scale: 0.75 }); // Image from right
  }

  // Define the animation for text and image, ensuring the image comes in 0.25 seconds after text
  tl
    .to(lineOne, { xPercent: 0, autoAlpha: 1, duration: 1 })
    .to(lineTwo, { xPercent: 0, autoAlpha: 1, duration: 1 }, "-=.75")
    .to(lineThree, { xPercent: 0, autoAlpha: 1, duration: 1 }, "-=.35")
    .to(button, { xPercent: 0, autoAlpha: 1, duration: 1 }, "-=.35")
    .to(image, { xPercent: 0, autoAlpha: 1, scale: 1, duration: 1 }, "-=1.8") // Image comes in 0.25s after text
    .to(allLinks, { y: 0, autoAlpha: 1, scale: 1, stagger: 0.4, rotationX: 0 });
}

// Apply the animation to each section
const sections = document.querySelectorAll(".k-row-1");
sections.forEach((section) => {
  createTextRevealAnimation(section);
});
